import { toString } from '@liquorice/utils';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useEffect, useState } from 'react';
import { useDayjs } from './useDayjs';

dayjs.extend(duration);

export function useCountdown(eventReleaseDate?: string | null) {
  const [countdownActive, setCountdownActive] = useState(false);
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    if (!eventReleaseDate) return;

    const releaseTime = useDayjs(eventReleaseDate);

    const updateCountdown = () => {
      const now = useDayjs();
      const diff = releaseTime.diff(now);

      if (diff <= 0) {
        setCountdownActive(false);
        return;
      }

      setCountdownActive(true);

      const durationObj = dayjs.duration(diff);

      const hours = toString(durationObj.hours()).padStart(2, '0');
      const minutes = toString(durationObj.minutes()).padStart(2, '0');
      const seconds = toString(durationObj.seconds()).padStart(2, '0');

      setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);

    return () => clearInterval(timer);
  }, [eventReleaseDate]);

  return { countdownActive, timeLeft };
}
